import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import { Provider } from 'mobx-react';
import './common/global-styles';

import RootApp from './RootApp';
import appStore from './stores/App.store';
import { unregister } from './registerServiceWorker';

/* Disable ESlint rules for this file */
/* eslint react/jsx-filename-extension: "off" */

const hasGoogleTagManagerID = !!process.env.REACT_APP_TAG_MANAGER_ID;

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_TAG_MANAGER_ID,
};

if (hasGoogleTagManagerID) {
  TagManager.initialize(tagManagerArgs);
}

ReactDOM.render(
  <Provider appStore={appStore}>
    <RootApp />
  </Provider>,
  global.document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js